<template>
  <div>
    <div class="app-title">
      <em-view-title key="viewTitle"
                     :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <div class="app-content">
      <div class="card">
        <QualityInspectTemplateTitleUnit class="mt-2" :node-data="nodeData"
                                         ref="template"></QualityInspectTemplateTitleUnit>
      </div>
      <el-button class="mt-2" type="info" plain @click="submitTemplateData" :loading="submitButtonLoading">保 存</el-button>
    </div>
  </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import QualityInspectTemplateTitleUnit
  from "@/views/sithMes/quality/inspectTemplate/cells/QualityInspectTemplateTitleUnit";
import emCommonListMixin from "@/mixin/em/common/list";

export default {
  name: "SithMesQualityInspectTemplateAddView",
  components: {QualityInspectTemplateTitleUnit},
  mixins: [EmCommonApi, emCommonListMixin],
  data() {
    return {
      nodeData: {},
      submitButtonLoading: false
    }
  },
  mounted() {
    let templateId = this.$route.query.templateId;
    if (templateId !== undefined && templateId != null) {
      this.queryTemplate(templateId);
    } else {
      //init
      this.nodeData = {
        name: '',
        type: 1,
        seq: 1,
        childNodes: []
      }
    }
  },
  methods: {
    submitTemplateData() {
      let exportData = this.$refs['template'].exportData();
      if (exportData != null) {
        this.submitButtonLoading = true;
        const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesQualityInspectTemplate")}/sithMesQualityInspectTemplate/saveTemplate`;
        this.$_emApiMixin_post(_api, exportData)
        .then(() => {
          this.submitButtonLoading = false;
          this.$message.success('保存成功');
          // this.$router.push("/sithMes/quality/sithMesQualityInspectTemplate/list");
        });
      }
    },
    queryTemplate(id) {
      const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesQualityInspectTemplate")}/sithMesQualityInspectTemplate/templateDetail`
      this.$_emApiMixin_post(_api, {id: id})
      .then(value => {
        this.nodeData = value.data;
        if (this.nodeData.seq === undefined || this.nodeData.seq == null) {
          this.nodeData.seq = 1;
        }
        if (this.nodeData.type === undefined || this.nodeData.type == null) {
          this.nodeData.type = 1;
        }
        if (!this.nodeData.hasOwnProperty('childNodes')) {
          this.nodeData.childNodes = [];
        }
      })
    }
  }
}
</script>

<style scoped>

</style>